document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".medications-swiper", {
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: false,
      on: {
        progress(swiper, progress) {
          const scrollbar = document.getElementById("slider-scrollbar");
          const thumb = document.getElementById("slider-thumb");
          const barWidth = scrollbar.offsetWidth;
          const thumbWidth = thumb.offsetWidth;
          const left = progress * (barWidth - thumbWidth);
          thumb.style.left = left + "px";
        },
      },
    });
  
    const scrollbar = document.getElementById("slider-scrollbar");
    const thumb = document.getElementById("slider-thumb");
  
    scrollbar.addEventListener("click", function (e) {
      const rect = scrollbar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const ratio = clickX / rect.width;
      const total = swiper.slides.length;
      const targetIndex = Math.round((total - 1) * ratio);
      swiper.slideTo(targetIndex);
    });
  });